import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
// @ts-expect-error
import {DragDropContext as dragDropContext} from 'react-dnd';
// @ts-expect-error
import HTML5Backend from 'react-dnd-html5-backend';
import {Provider} from 'react-redux';
import {Router, Route} from 'react-router-dom';
import {ShepherdJourneyProvider} from 'react-shepherd';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';
// @ts-expect-error
import bacon from 'baconjs';

import {nutApolloClient} from '../apollo-client';
import {appHistory} from '../history';
// @ts-expect-error
import {Dispatcher} from '../infrastructure/dispatcher';
import {store} from '../store';

import {AppWrappedInBacon} from './app-wrapped-in-bacon';

// TODO: Do we need these here? Likely yes.
import '../pages/filepicker-modal';
import 'less/app.less';
import 'less/report.less';

type Props = {
    appState: typeof bacon.Property;
    dispatcher: Dispatcher<any>;
};

// Entry point for the React app
// Looking for where this is rendered? Look at client/web/app.js start() method.

// Note: This is purposefully a class component due to some dragDropContext
// internal issues with functional components.
export function AppRoot({appState, dispatcher}: Props) {
    const App = dragDropContext(HTML5Backend)(
        class extends React.PureComponent<any> {
            render() {
                return (
                    <AppWrappedInBacon
                        {...this.props}
                        appState={appState}
                        dispatcher={dispatcher}
                    />
                );
            }
        }
    );

    return (
        <Provider store={store}>
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <Router history={appHistory}>
                        <ShepherdJourneyProvider>
                            <Route component={App} />
                        </ShepherdJourneyProvider>
                    </Router>
                </ReactHooksApolloProvider>
            </ApolloProvider>
        </Provider>
    );
}
